import { Box, Stack, Typography } from '@mui/material'
import { C1Card } from 'components/core/card/C1Card'
import { C1Icon } from 'components/core/icons/C1Icon'
import { Route } from 'lib/routes'
import { Star } from 'lucide-react'
import { FC } from 'react'
import { FormattedMessage } from 'react-intl'

type ReviewStyleBoxProps = {
    title: string
    subtitle: string
    description: string
    recommended?: boolean
    selected?: boolean
    onClick: () => void
    href: Route
    icon: React.ReactElement
}

export const ReviewStyleBox: FC<ReviewStyleBoxProps> = ({
    title,
    subtitle,
    description,
    recommended,
    selected,
    onClick,
    href,
    icon,
}) => {
    return (
        <C1Card href={href} onClick={onClick} isSelected={selected} sx={{ flexGrow: 1, flexBasis: 0 }}>
            {recommended && (
                <Box>
                    <C1Icon icon={Star} size="lg" />
                    <FormattedMessage id="review_style_box_recommended_text" defaultMessage="Recommended" />
                </Box>
            )}
            <Box color={selected ? 'primary.main' : 'inherit'}>
                <Stack mb={2}>
                    <Box>{icon}</Box>
                    <Typography variant="h5" component="p">
                        {title}
                    </Typography>
                    <Typography>{subtitle}</Typography>
                </Stack>
                <Typography>{description}</Typography>
            </Box>
        </C1Card>
    )
}
